import { Injectable } from '@angular/core';
import { isDefined } from '@fi-shared/utils/is-defined';
import { DocumentListingWidgetModel } from './model/document-listing-widget.model';
import { NewsFeedWidgetModel } from './model/news-feed-widget.model';
import { AdvancedTextWidgetModel } from './model/advanced-text-widget.model';
import { ForumFeedWidgetModel } from './model/forum-feed-widget.model';
import { ForumListingWidgetModel } from './model/forum-listing-widget.model';
import { SiteMapWidgetModel } from './model/site-map-widget.model';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { FormListingWidgetModel } from '@fi-app/widget/model/form-listing-widget-model';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class WidgetRegisterService {
    private registry: {
        [key: string]: {
            new (initializeItem, fiFormatDateService: FiFormatDateService): WidgetModel;
        };
    } = {
        DocumentListing: DocumentListingWidgetModel,
        NewsFeed: NewsFeedWidgetModel,
        AdvancedText: AdvancedTextWidgetModel,
        ForumListing: ForumListingWidgetModel,
        ForumFeed: ForumFeedWidgetModel,
        SiteMap: SiteMapWidgetModel,
        FormListing: FormListingWidgetModel,
    };
    private sortOrder = [
        'DocumentListing',
        'SiteMap',
        'ForumListing',
        'NewsFeed',
        'ForumFeed',
        'AdvancedText',
        'FormListing',
    ];

    constructor() {}

    getWidgetPrototype(
        contentLanguages: IContentLanguage[],
        widgetName: string,
    ): {
        new (contentLanguages, fiFormatDateService, initializeItem): WidgetModel;
    } {
        if (isDefined(this.registry[widgetName])) {
            return this.registry[widgetName];
        } else {
            throw (
                'Widget "' +
                widgetName +
                '" is not registered. Use "registry" variable to add this widget in the registry.'
            );
        }
    }
    getWidgetSortOrder(widgetName: string) {
        return this.sortOrder.indexOf(widgetName);
    }
}
